import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { usePWA } from '../context/PWAContext';

export const PWAInstallPrompt: React.FC = () => {
  const { isInstallable, showInstallPrompt } = usePWA();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isInstallable) {
      // Show prompt if installable
      setVisible(true);
    }
  }, [isInstallable]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white dark:bg-slate-800 rounded-xl shadow-2xl border border-slate-200 dark:border-slate-700 p-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center text-white shadow-lg">
             <span className="font-bold text-xl">M</span>
          </div>
          <div>
            <h3 className="font-bold text-slate-900 dark:text-white leading-tight">Install Portal MIAS</h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Akses lebih cepat dan mudah tanpa browser.</p>
          </div>
        </div>
        <button
          onClick={() => setVisible(false)}
          className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 p-1"
        >
          <X size={18} />
        </button>
      </div>

      <div className="mt-4 flex gap-2">
        <button
          onClick={() => {
            showInstallPrompt();
            setVisible(false);
          }}
          className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors shadow-sm"
        >
          <Download size={16} />
          Install Aplikasi
        </button>
        <button
          onClick={() => setVisible(false)}
          className="px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
        >
          Nanti
        </button>
      </div>
    </div>
  );

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white dark:bg-slate-800 rounded-xl shadow-2xl border border-slate-200 dark:border-slate-700 p-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center text-white shadow-lg">
             <span className="font-bold text-xl">M</span>
          </div>
          <div>
            <h3 className="font-bold text-slate-900 dark:text-white leading-tight">Install Portal MIAS</h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Akses lebih cepat dan mudah tanpa browser.</p>
          </div>
        </div>
        <button
          onClick={handleClose}
          className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 p-1"
        >
          <X size={18} />
        </button>
      </div>

      <div className="mt-4 flex gap-2">
        <button
          onClick={handleInstallClick}
          className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors shadow-sm"
        >
          <Download size={16} />
          Install Aplikasi
        </button>
        <button
          onClick={handleClose}
          className="px-4 py-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
        >
          Nanti
        </button>
      </div>
    </div>
  );
};
